// Overall validation status of the entire upload
export enum UploadValidationStatus {
  InProcess,
  Success,
  HasWarnings,
  HasErrors,
}
